import Routes from './routes';
import { createRouter, createWebHistory } from 'vue-router';
import AuthGuard from './guards/auth';
import UserGuard from './guards/user';
import GuestGuard from './guards/guest';
import OwnerGuard from './guards/owner';
import NumberGuard from './guards/number';
import AgencyGuard from './guards/agency';
import DeveloperGuard from './guards/developer';
import InvitationGuard from './guards/invitation';
import SubscriptionGuard from './guards/subscription';
import PermissionGuard from './guards/permission';
import FeatureFlagGuard from './guards/featureFlag';
import TenDLCGuard from './guards/tenDLC';
import TeamsGuard from './guards/teams';
import ProfileSavedRepliesGuard from './guards/profileSavedReplies';

const originalPush = createRouter.prototype.push;
const originalReplace = createRouter.prototype.replace;

createRouter.prototype.push = function push(location) {
    return originalPush.call(this, location)?.catch((err) => err);
};

createRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location)?.catch((err) => err);
};

const Router = createRouter({
    history: createWebHistory(),
    routes: Routes,
    linkActiveClass: 'is-active',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    },
});

// This is hacky as hell, but needed to ensure the bootstrap modals
// have their backdrops removed on back navigation.
Router.beforeEach((to, from, next) => {
    $('.modal-backdrop').remove();
    next();
});

// DO NOT ALTER ORDER
// These fire in a very specific order to ensure the application load doesn't
// throw a fit.

// These guards will run checks prior to initializing the application to ensure
// the request route is viewable.
Router.beforeEach(InvitationGuard);
Router.beforeEach(UserGuard);

// These guards check to different states and redirect based on the user set
// on Vuex.
Router.beforeEach(AuthGuard);
Router.beforeEach(GuestGuard);
Router.beforeEach(OwnerGuard);
Router.beforeEach(DeveloperGuard);

// These guard check user permission
Router.beforeEach(PermissionGuard);

// These guard check feature flag
Router.beforeEach(FeatureFlagGuard);

// These guards are here to ensure the user has the proper account attributes
// to use the application.
Router.beforeEach(NumberGuard);
Router.beforeEach(SubscriptionGuard);
Router.beforeEach(AgencyGuard);

// These guard check 10DLC subscription and business profile
Router.beforeEach(TenDLCGuard);

// These guard check if the user can manage teams by feature flag and role
Router.beforeEach(TeamsGuard);

// These guard check if the user can manage saved replies by feature flag
Router.beforeEach(ProfileSavedRepliesGuard);

// Segment.IO Page Tracking
Router.afterEach(function (to, from) {
    if (!window.analytics) {
        return;
    }

    // If HubSpot iFrame, don't do anything ever.
    if (window.Config.hasOwnProperty('assuming')) {
        window.analytics.page(
            {},
            {
                Intercom: {
                    hideDefaultLauncher: true,
                },
            }
        );

        return;
    }

    window.analytics.page(to.fullPath, {
        path: to.fullPath,
        referrer: from.fullPath,
    });
});

export default Router;
